import React from 'react'

import { connect } from 'react-redux';
import { navigateTop } from '../routing/router-utils';
import { trackEvent } from '../analytics/tracking';
import BodyWrapper, { LayoutTypes } from '../layout/BodyWrapper';
import PrimaryHeader from '../styleguide/PrimaryHeader';
import MediumButton from '../styleguide/MediumButton';
import Spinner from '../common/Spinner';
import BasicButton from '../styleguide/BasicButton';
import BagIcon from '../checkout/BagIcon';
import PropTypes from 'prop-types'

/* There is only 1 unique style in this component, I've inlined it */
import styles from '../common/SwitchDispensaryWarning.module.css';

const SwitchDispensary = ({ 
  dispensaryId,
  cartDispensaryId,
  dispensaryMap={},
  cartItems,
}) => {

  const [dispensary, setDispensary] = React.useState({});
  const [cartDispensary, setCartDispensary] = React.useState({});

  const wrapperStyle = {
    width: '700px',
    maxWidth: '95vw',
    margin: '0 auto',
    padding: '3rem 0'
  }; 

  React.useEffect(() => {
    if (dispensaryMap.get && 
        !(dispensary.id && cartDispensary.id)) {
      
      const newDispensary = dispensaryMap.get(dispensaryId);
      const currentDispensary = dispensaryMap.get(cartDispensaryId);
      
      // If there are no cart items, or we're not switching dispensaries 
      // proceed to the requested dispensary
      if (dispensaryId === cartDispensaryId || 
        (cartItems && cartItems.length === 0)) {
        navigateTop(`/dispensary/${dispensaryId}`, { replace:true });
      }
      
      if (newDispensary && currentDispensary) {
        setDispensary(newDispensary);
        setCartDispensary(currentDispensary);
      } else {
        trackEvent('error_setting_dispensary_warning',`${dispensaryId}`);
      }
    }
  }, [cartItems, dispensaryId, cartDispensaryId, dispensaryMap, dispensary.id, cartDispensary.id, setDispensary, setCartDispensary]);

  return (
    <BodyWrapper layout={LayoutTypes.Narrow}>
       <div style={wrapperStyle}>
       { dispensary.name 
        ? <>    
            <div className={styles.headerWrap}>
              <PrimaryHeader isCentered>
                <BagIcon size="36"/> Start new bag? 
              </PrimaryHeader>
            </div>
            <div className={styles.warning}>
              Your shopping bag contains item(s) from  
              <span onClick={() => navigateTop(`/dispensary/${cartDispensary.id}`)} className={styles.dispensaryLink}>
                {` ${cartDispensary.name}. `}
              </span>
            </div>   
            <div className={styles.warning}>
              Would you like to empty your bag and continue to
              <span onClick={() => navigateTop(`/dispensary/${dispensary.id}`)} className={styles.dispensaryLink}>
                {` ${dispensary.name}`}? <sup>*</sup>
              </span>
            </div>
            <div className={`${styles.warning} ${styles.footnote}`}>
              <sup>*</sup>State regulations limit dispensary orders to 1 per day.
            </div>
            <div className={styles.buttons}>
              <BasicButton text="Cancel" handleClick={() => window.history.back()} />
              <MediumButton text="Continue" handleClick={() => navigateTop(`/dispensary/${dispensaryId}`)} />
            </div>
          </>
        : <Spinner />
      }
      </div>       
    </BodyWrapper>
  );
}

SwitchDispensary.propTypes = {
  dispensaryId: PropTypes.string,
  cartDispensaryId: PropTypes.string,
  dispensaryMap: PropTypes.object, 
  cartItems: PropTypes.array
}
 
const mapStateToProps = (state) => {
  return {
    cartDispensaryId: state.dispensaryId,
    dispensaryMap: state.dispensaryMap, 
    cartItems: state.addedItems
  }
}

export default connect(mapStateToProps)(SwitchDispensary);